<div
  [id]="formIdentifier('entireContainer')"
  class="containerWrapper"
>
  <div
    style="font-weight: bold"
  >
    {{tableHeadName}}
  </div>
  <div
    class="tableContainer"
  >
    <table
      class="entireTableStyle"
      cellpadding="0"
    >
      <thead
        class="tableHeaderStyle"
      >
      <tr>
        <th
          *ngFor="let headerName of headerNames"
        >
          <div
            class="headerCellContentStyle"
          >
            {{headerName}}
          </div>
        </th>
        <th>
          <div class="headerCellContentStyle"></div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr
        *ngFor="let rowData of getTableDataToDisplay(); index as index"
        class="tableBodyRowStyle"
      >
        <td>
          <div
            class="bodyCellContentStyle"
          >
            <input
              [id]="formIdentifier('from', index)"
              type='number'
              [ngModel]="rowData.from"
              (change)="handleIncrementDecrement(
              $event,
              rowData,
              'from',
              'to',
              false
              )"
              min="1"
            >
          </div>
        </td>
        <td>
          <div
            class="bodyCellContentStyle"
          >
            <input
              [id]="formIdentifier('to', index)"
              type='number'
              [ngModel]="rowData.to"
              (change)="handleIncrementDecrement(
              $event,
              rowData,
              'to',
              'from'
              )"
            >
          </div>
        </td>
        <td>
          <div
            class="bodyCellContentStyle"
          >
            <input
              [id]="formIdentifier('balls', index)"
              type='number'
              [ngModel]='rowData.balls'
              (change)="handleBallsInput($event, rowData)"
            >
          </div>
        </td>
        <td>
          <div
            class="bodyCellContentStyle"
          >
            <i
              [id]="formIdentifier('delete', index)"
              (click)="deleteCertainRow(index)"
              [ngClass]="deleteIconStyle()"
            ></i>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div
    [id]="formIdentifier('add')"
    class="addBallsRowButton"
    (click)="appendNewRow()"
  >
    {{addBallsRowButtonText}}
  </div>
</div>
